<template>
  <div class="login-page">
      <div class="col-md-4 language-block">
        <v-select
          :items="langs"
          @change="changeLanguage()"
          v-model="selectedLanguage"
        >
          <template v-slot:selection="{ item, index }">
            <country-flag :country="item.flag" size="normal" />
            <span class="flags pl-2">{{ item.name }}</span>
          </template>
          <template v-slot:item="{ item, index }">
            <country-flag :country="item.flag" size="normal" />
            <span class="flags pl-2">{{ item.name }}</span>
          </template>
        </v-select>
      </div>
      <div class="container-fluid full-height-center">
        <flash-message
          v-if="flashAlertToggle"
          :message-data="flashMessageData"
          :alert-toggle="flashAlertToggle"
          @alertToggleUpdate="flashAlertToggle = false"
        ></flash-message>
        <div class="row justify-content-md-center login-inner-detail">
          <div class="col col-lg-5 col-md-6">
            <div class="logo text-center my-6">
              <a href="#" class="my-4 d-inline-block">
                <img src="../../assets/logo.png" width="240" />
              </a>
              <p class="my-3">{{ "lng_dealer_welcome_text" | translate}}</p>
            </div>
            <div class="login-form">
              <v-form ref="login" lazy-validation>
                <v-text-field
                  :label="'lng_email_text' | translate"
                  type="email"
                  v-model="email"
                  :rules="[rules.required, rules.email]"
                ></v-text-field>
                <v-text-field
                  :label="'lng_password_text' | translate"
                  type="text"
                  @click:append="showPass = !showPass"
                  v-on:keyup.enter="validate"
                  v-model="password"
                  :rules="[rules.required]"
                ></v-text-field>
                <p class="warning-error mt-2" v-if="error">{{ error }}</p>
                <div class="date-header d-flex justify-content-center py-5 mt-3">
                  <v-btn :loading="loginLoading" color="#0B7894" dark @click="validate">{{ "lng_login_text" | translate}}</v-btn>
                </div>
                <div class="text-center">
                  <v-btn @click="openForgotPassModal" text small>{{ "lng_forgot_password_text" | translate}}</v-btn>
                </div>
              </v-form>
            </div>
          </div>
        </div> 
    </div>
    <ForgotPasswordModal
      :dialog-title="'lng_forgot_pass_heading_txt' | translate"
      :openDialog="forgotPassModalToggle"
      :closeDialog="closeForgotPassModalFunc"
    ></ForgotPasswordModal>
  </div>
</template>

<script>
import router from "../../router";
import UserService from "../../services/user-service";
import GlobalService from "../../services/global-service.js"
import { translateFunc } from '../../common/Filters';
import { languages, langFileVersion } from "../../common/Constant.js"
import CountryFlag from "vue-country-flag";
import FlashMessage from "../../components/FlashMessage";
import ForgotPasswordModal from "../../components/ForgotPasswordModal"

export default {
  name: "DealerLogin",
  components: {
    CountryFlag,
    FlashMessage,
    ForgotPasswordModal
  },
  data: () => ({
    langs: languages,
    selectedLanguage: undefined,
    showPass: false,
    loginLoading: false,
    email: "",
    password: "",
    error: "",
    rules: {
      required: value => !!value || translateFunc("lng_required_text"),
      counter: value => value.length <= 20 || translateFunc("lng_required_length"),
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || translateFunc("lng_required_validate_email");
      }
    },
    flashMessageData: {},
    flashAlertToggle: false,
    forgotPassModalToggle: false,
    langVersion: langFileVersion
  }),
  mounted(){
    let langName = localStorage.getItem('language');
    let filtered = languages.find(e => e.lang === langName);
    if(filtered){
      this.selectedLanguage = filtered;
    } else {
      localStorage.setItem("language", "dk");
      this.selectedLanguage = languages[1];
    }
    /* if(this.$route.query.temptoken){
      this.temporaryTokenLogin(this.$route.query.temptoken);
    } */
  },
  methods: {
    goToSignup() {
      router.push("/signup");
    },
    // validate the login fields
    validate() {
      const that = this;
      this.$nextTick(async function() {
        if (that.$refs.login.validate()) {
          await this.login();
        }
      });
    },
    // login function
    async login() {
      this.error = "";
      this.loginLoading = true;
      let response;
      try {
        response = await UserService.dealerLogin(this.email, this.password);
      } catch (e) {
        this.error = translateFunc("lng_try_again_txt");
        this.loginLoading = false;
        console.log("e: ", e);
      }
      if (!response.status) {
        this.error = "";
        this.loginLoading = false;
        let infoData = await GlobalService.getDealerInfo(response.token);
        localStorage.setItem("userToken", response.token);
        localStorage.setItem("authLevel", "3");
        router.push("/admin-home");
        /* if(infoData.dealer && infoData.dealer.authlevel === "3"){
          router.push("/admin-home");
        } else {
          router.push("/dealer-home");
        } */
      } else {
        this.loginLoading = false;
        this.error = translateFunc("lng_login_error_txt");
      }
    },
    // store language to session
    async changeLanguage() {
      localStorage.setItem("language", this.selectedLanguage.lang);
      window.selectedLang = require(`../../../public/locales/${this.selectedLanguage.lang + this.langVersion}.json`);
      // window.I18n = new I18n(this.selectedLanguage.lang);
    },
    async temporaryTokenLogin(token){
      this.loginLoading = true;
      let response;
      try {
        response = await UserService.tempLogin(token);
      } catch (e) {
        this.error = translateFunc("lng_try_again_txt");
        this.loginLoading = false;
        console.log("e: ", e);
      }
      console.log("resposne: ", response);
      if (!response.status) {
        this.loginLoading = false;
        localStorage.setItem("userToken", response.token);
        if(this.$route.query.forgotpassword){
          router.push(`/user-settings`);
        } else router.push(`/`);
      } else {
        this.loginLoading = false;
        this.flashMessageData = {
          type: "error",
          messageText: translateFunc("lng_expire_token_txt")
        };
        this.flashAlertToggle = true;
      }
    },
    openForgotPassModal(){
      this.forgotPassModalToggle = true
    },
    closeForgotPassModalFunc(){
      this.forgotPassModalToggle = false
    }
  }
};
</script>

<style scoped>
.full-height-center{
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>